// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.svg-icon[data-v-c8a70580] {\r\n  width: 1em;\r\n  height: 1em;\r\n  vertical-align: -0.15em;\r\n  fill: currentColor;\r\n  overflow: hidden;\n}\n.svg-external-icon[data-v-c8a70580] {\r\n  background-color: currentColor;\r\n  -webkit-mask-size: cover!important;\r\n          mask-size: cover!important;\r\n  display: inline-block;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
